import { z } from 'zod';

export const phoneSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(100),
  phone: z
    .string()
    .min(10, 'Phone is required')
    .max(15)
    .regex(/^\d+$/, 'Phone must contain only numbers'),
  is_default: z.boolean(),
});

export type PhoneInput = z.infer<typeof phoneSchema>;
